import { useEffect } from "react";

const HOTJAR_ID = "5142549";
const HOTJAR_SV = 6;

declare global {
    interface Window {
        hj?: (...args: any[]) => void;
        _hjSettings?: { hjid: number; hjsv: number };
    }
}

export const useHotjar = () => {
    useEffect(() => {
        if (!HOTJAR_ID) return;

        (function (h: any, o: Document, t: string, j: string, a?: HTMLElement, r?: HTMLScriptElement) {
            h.hj = h.hj || function () { (h.hj.q = h.hj.q || []).push(arguments); };
            h._hjSettings = { hjid: HOTJAR_ID, hjsv: HOTJAR_SV };
            a = o.getElementsByTagName('head')[0];
            r = o.createElement('script');
            r.async = true;
            r.src = t + h._hjSettings.hjid + j + h._hjSettings.hjsv;
            a.appendChild(r);
        })(window, document, 'https://static.hotjar.com/c/hotjar-', '.js?sv=');
    }, []);
}
